module.exports = __webpack_public_path__ + "img/leona.f54cc696.jpg";